export default {
  common: {
    close: '閉じる',
    submit: '提出する',
    answer: '回答',
    un_answer: '未回答',
    next: 'next',
    see_all: 'もっと見る',
    exam_result: 'テストが採点されました',
    result: '結果'
  },
  menu: {
    home: 'ホーム',
    my_test: 'マイテスト',
    exam_dashboard: 'ダッシュボード',
    catalog: 'テスト一覧',
    exam_recommendation: 'おすすめテスト',
    myprofile: 'マイプロファイル',
    notification: '通知',
    notice: '通知',
    my_question: 'マイ質問',
    questions: '質問一覧',
    configuration: '設定',
    account: 'アカウント切り替え',
    premium_service: 'プレミアムサービス',
    subscription: '購入済み',
    course: 'マイコース',
    logout: 'ログアウト',
    dashboard: 'ダッシュボード',
    goal: 'ゴール',
    information: 'お知らせ',
    inquiry: '問い合わせ'
  },
  exam_list: {
    start: 'テスト開始',
    continue: '引き続きテスト',
    time_over: 'テスト時間超過',
    go_test_list: 'テスト一覧を見る'
  },
  exam_show: {
    start: '今すぐテスト開始する',
    continue: '引き続きテストする',
    time_over: '結果を見る',
    go_test_list: 'テスト一覧を見る'
  },
  question: {
    warning_start_exam: 'テスト開始してください！',
    problem: '問題',
    answer_number: '回答数',
    question: '問目',
    description: '説明',
    answer_rate: 'アンサーレット',
    work_sheet: 'アンケート',
    group: 'グループ',
    completion_status: '完了ステータス',
    response: '現在の回答率は',
    done: 'これで良い場合は左にある「提出」をクリックしてください。',
    not_done: '左の問題メニューから未回答の問題をクリックして回答しましょう。',
    progress: '%です'
  },
  exam_result: {
    warning_finish_exam: 'テスト完了してください！!',
    failure: '不合格',
    pass: '合格',
    place: '位',
    people: '人中',
    national_average: '全国平均',
    target_value: '目標値',
    problem: '問題',
    sub_problem: '問目',
    skill_items: 'スキルアイテム',
    average_point: 'average point',
    average: 'average',
    description: '説明',
    commentary: '解説',
    commentary_description:
      '情に棹させば流される。智に働けば角が立つ。どこへ越しても 住みにくいと悟った時、詩が生れて、画が出来る。とかくに人 の世は住みにくい。意地を通せば窮屈だ',
    check_score: '採点中',
    show_detail: '回答を見る',
    stats: 'スタッツ'
  },
  user: {
    update_completed: 'ユーザーアップデートしました。'
  },
  notification_action: {
    ask: '質問しました',
    comment: 'コメントしました',
    answer: 'アンサーしました',
    marked_exam: 'テストが採点されました',
    submit_exam: 'テストが提出しました',
    inquiry: '問い合わせしました',
    cheating_detected: 'カンニング発見しました',
    choose_best_answer: 'ベスト答えを選択しました',
    submit_assignment: '課題を提出しました',
    vote_down: '「良くない」しました',
    vote_up: 'いいねしました',
    information: '新規のお知らせを届きました',
    teacher_approved_booking: '面接に応じます。',
    zoom_ready: 'Zoomの準備ができました。',
    teacher_rejected_booking: '面接はキャンセルされました。',
    create_booking: 'インタビューが作成されました。',
    course_purchase: '購入したコース。',
    resolve_question: '質問が解決されました'
  }
}
